(function($) {
  const $eventFilter = $('.events .events-filters');
  const $categoryTabs = $eventFilter.find('.filter');
  const $performances = $('.events .performance');
  const $months = $('.events .month-wrapper');
  const $noPerformancesMessage = $('.no-performances-message');

  let activeCategoryId = null;
  var filters = {
    level: '',
    ageGroup: ''
  };

function applyAllFilters() {
  let anyVisible = false;

  $performances.each(function () {
    const $perf = $(this);
    const levels = ($perf.data('level') || '').toString().split(',').map(s => s.trim());
    const ageGroups = ($perf.data('age-group') || '').toString().split(',').map(s => s.trim());
    let categoryIds = $perf.attr('data-category');

    try {
      categoryIds = JSON.parse(categoryIds); // expects [1,2,3]
    } catch (e) {
      categoryIds = [];
    }

    const matchCategory = !activeCategoryId || categoryIds.includes(activeCategoryId);
    const matchLevel = !filters.level || levels.includes(filters.level);
    const matchAge = !filters.ageGroup || ageGroups.includes(filters.ageGroup);

    const matches = matchCategory && matchLevel && matchAge;

    if (matches) {
      $perf.removeClass('filtered-out');
      anyVisible = true;
    } else {
      $perf.addClass('filtered-out');
    }
  });

  // Show/hide months based on non-filtered performances
  $months.each(function () {
    const $month = $(this);
    const hasVisible = $month.find('.performance').not('.filtered-out').length > 0;

    if (hasVisible) {
      $month.removeClass('filtered-out');
    } else {
      $month.addClass('filtered-out');
    }
  });

  // Toggle no-performances message
  if ($noPerformancesMessage.length) {
    $noPerformancesMessage.toggleClass('show', !anyVisible);
  }
}






  if ($(".events").length > 0) {
    $categoryTabs.on('click', function (e) {
      e.preventDefault();

      const $clicked = $(this);
      const clickedCatId = parseInt($clicked.data('category-id'), 10);
      if ($clicked.hasClass('active')) return;

      $categoryTabs.removeClass('active').addClass('not-active');
      $clicked.removeClass('not-active').addClass('active');

      activeCategoryId = clickedCatId;

      applyAllFilters();
      writeEventStateToURL();
    });

    $('#filter-level').on('change', function () {
      filters.level = $(this).val();
      applyAllFilters();
      writeEventStateToURL();
    });

    $('#filter-age-group').on('change', function () {
      filters.ageGroup = $(this).val();
      applyAllFilters();
      writeEventStateToURL();
    });

  }

  function readEventStateFromURL() {
    const params = new URLSearchParams(window.location.search);
    const catIdParam = params.get('category');
    const levelParam = params.get('level');
    const ageGroupParam = params.get('ageGroup');

    // Handle tab selection
    if (catIdParam !== null) {
      const catId = parseInt(catIdParam, 10);
      activeCategoryId = catId;

      $categoryTabs.removeClass('active').addClass('not-active');
      const $matchedTab = $categoryTabs.filter(function() {
        return parseInt($(this).data('category-id'), 10) === catId;
      });

      if ($matchedTab.length) {
        $matchedTab.removeClass('not-active').addClass('active');
      }
    } else {
      const $first = $categoryTabs.first();
      activeCategoryId = parseInt($first.data('category-id'), 10);
      $first.removeClass('not-active').addClass('active');
    }

    // Set filters from URL if present
    if (levelParam !== null) {
      filters.level = levelParam;
      $('#filter-level').val(levelParam);
    }

    if (ageGroupParam !== null) {
      filters.ageGroup = ageGroupParam;
      $('#filter-age-group').val(ageGroupParam);
    }

    applyAllFilters();
  }

  function writeEventStateToURL() {
    const currentParams = new URLSearchParams(window.location.search);

    if (activeCategoryId) {
      currentParams.set('category', activeCategoryId);
    } else {
      currentParams.delete('category');
    }

    if (filters.level) {
      currentParams.set('level', filters.level);
    } else {
      currentParams.delete('level');
    }

    if (filters.ageGroup) {
      currentParams.set('ageGroup', filters.ageGroup);
    } else {
      currentParams.delete('ageGroup');
    }

    const newUrl = `${location.pathname}?${currentParams.toString()}`;
    history.replaceState({}, '', newUrl);
  }


  $(document).ready(function() {
    $categoryTabs.addClass('not-active');
    readEventStateFromURL();
  });
})(jQuery);
